import { render } from "./videoCom.vue?vue&type=template&id=5cdde582&scoped=true&ts=true"
import script from "./videoCom.vue?vue&type=script&lang=ts"
export * from "./videoCom.vue?vue&type=script&lang=ts"

import "./videoCom.vue?vue&type=style&index=0&id=5cdde582&scoped=true&lang=less"

import exportComponent from "/workspace/source-code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cdde582"]])

export default __exports__